export default __webpack_public_path__ + "static/media/left_slightly_highArch.63311bb2.png";